<template>
  <div class="main-card mb-3 card">
    <div class="card-header">Backup &amp; restore</div>
    <div class="card-body">
      <div class="position-relative mb-0 form-group w-100">
        <div class="col-12 p-0">
          <button type="submit" class="btn btn-outline-success mr-2" @click.stop.prevent="handleBackupNow">Backup now</button>
          <button type="submit" class="btn btn-outline-success mr-2" @click.stop.prevent="handleListBackup">List backup</button>
          <button type="submit" class="btn btn-outline-success mr-2" @click.stop.prevent="handleDownloadBackup">Download backup</button>
          <button type="submit" class="btn btn-outline-warning mr-2" @click.stop.prevent="handleClearBackup">Clear backup</button>
          <button type="submit" class="btn btn-outline-danger mr-2" @click.stop.prevent="handleRestoreBackup">Restore</button>
        </div>
        <div v-if="Object.keys(data).length > 0" class="col-12 mt-4 p-0">
          <ul class="list-group">
            <button v-for="(item, index) in data" :key="index" :class="`${values == item ? 'active' : ''} list-group-item-action list-group-item`" @click.stop.prevent="values = item">
              {{ item }}
            </button>
          </ul>
        </div>
        <div v-if="logs" class="w-100 mt-4" style="white-space: pre-line; max-height: 400px; overflow: auto; background: #000; color: #dfdfdf; padding: 20px">
          {{ logs }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  data() {
    return {
      data: [],
      logs: null,
      values: null
    }
  },
  methods: {
    handleListBackup() {
      this.$util.get(`backup`, null, this.$el).then((response) => {
        if (response.status == 'success') {
          this.data = response.data || []
          this.values = null
        }
      })
    },
    handleBackupNow() {
      this.$util.post(`backup/create`, null, this.$el).then((response) => {
        if (response.status == 'success') {
          this.data = response.data || []
          this.values = null
        }
      })
    },
    handleDownloadBackup() {
      this.$util
        .post(
          `backup/download`,
          {
            values: this.values
          },
          this.$el
        )
        .then((response) => {
          if (response.status == 'success' && response.data.url) {
            const link = document.createElement('a')
            link.href = response.data.url
            link.style.display = 'none'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        })
    },
    handleClearBackup() {
      this.$util.post(`backup/clear`)
    },
    handleRestoreBackup() {
      this.$util
        .post(`backup/restore`, {
          values: this.values || ''
        })
        .then((response) => {
          if (response.status == 'success') {
            this.logs = response.data.logs
          }
        })
        .catch((response) => {
          this.logs = response.data.logs || null
        })
    }
  }
}
</script>
